import React, { useEffect, useState, useRef } from "react";
import { object } from "prop-types";

import { Dropdown } from "../../atoms/Dropdown";
import MagazineEditions from "../../../arrow/components/Rows/MagazineEditions";
import { STATIC_KEYWORDS } from "../../../constants";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { trackLoadMoreClick } from "../../utils";

import "./all-magazines-listing-page.m.css";

export const AllMagazinesListingPage = ({ data }) => {
  const [collection, setCollection] = useState(data.data);

  const config = {
    showRowTitle: false,
    showBottomReadMore: true,
    showTitleReadMore: false,
  };

  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";

  const limit = isDesktop ? 15 : 12;

  const [currentLimit, setCurrentLimit] = useState(12);
  const [isLoading, setIsLoading] = useState(false);

  const isLoadingRef = useRef(false);
  const lastLoadScrollRef = useRef(0);

  const {
    FORTUNE_INDIA_MAGAZINE,
    NO_MAGAZINE_ISSUES_FOUND,
  } = STATIC_KEYWORDS;

  // Set correct initial limit after device type is detected
  useEffect(() => {
    setCurrentLimit(limit);
    lastLoadScrollRef.current = 0;
  }, [limit]);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "dl_page_info",
      cms_author_name: "NA",
      byline: "NA",
      category: "magazine",
      sub_category: "NA",
      content_id: "NA",
      template_name: "listing",
      publish_date: "NA",
      publish_time: "NA",
      login_status: "not-logged-in",
      subscription_status: "not-subscribed",
      ad_free: false,
      login_wall_enabled: false,
      platform:
        window.innerWidth >= 768
          ? "Desktop"
          : "Mobile",
    });
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      // Don't trigger at the top
      if (scrollY <= 0) {
        return;
      }

      // Don't trigger while loading
      if (isLoadingRef.current) {
        return;
      }

      // Don't trigger when all data is loaded
      if (currentLimit >= collection.length) {
        return;
      }

      const scrollableHeight =
  document.documentElement.scrollHeight - window.innerHeight;

const scrollPercentage =
  (window.scrollY / scrollableHeight) * 100;
      if (scrollPercentage >= 50)
      {
        isLoadingRef.current = true;

        lastLoadScrollRef.current = scrollY;
        console.log("Loading more magazines...");
        setIsLoading(true);

        trackLoadMoreClick({
          linkCategory: "magazine",
          category: "magazine",
          subCategory: "NA",
          templateName: "listing",
        });

        setCurrentLimit((prevLimit) =>
          Math.min(
            prevLimit + limit,
            collection.length
          )
        );
      }
    };

    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [currentLimit, collection.length, limit]);

  // Hide loader after new items are rendered
  useEffect(() => {
    if (!isLoading) {
      return;
    }

    const frame = requestAnimationFrame(() => {
      setIsLoading(false);
      isLoadingRef.current = false;
    });

    return () => cancelAnimationFrame(frame);
  }, [currentLimit, isLoading]);

  return (
    <div
      className="container"
      styleName="magazines-listing-page"
    >
      <div styleName="collection-title-container">
        <h1 styleName="collection-title">
          {FORTUNE_INDIA_MAGAZINE}
        </h1>

        <Dropdown
          collection={collection}
          onSelect={setCollection}
        />
      </div>

      {collection.length > 0 ? (
        <>
          <div styleName="magazine-editions-container">
            <MagazineEditions
              collection={collection}
              config={config}
              limit={currentLimit}
              isStoryPage={false}
              pageType="all-magazines-listing-page"
            />
          </div>

          {isLoading && (
            <div styleName="load-more-loader">
              <div styleName="loader" />
            </div>
          )}
          {/* {currentLimit < collection.length && (
        <div styleName="load-more-button">
          <button
            onClick={() => {
              setCurrentLimit((prevLimit) => prevLimit + limit);
              trackLoadMoreClick({
                linkCategory: "magazine",
                category: "magazine",
                subCategory: "NA",
                templateName: "listing",
              });
            }}
          >
            {LOAD_MORE}
          </button> */}
        </>
      ) : (
        <div styleName="no-magazine">
          {NO_MAGAZINE_ISSUES_FOUND}
        </div>
      )}
    </div>
  );
};

AllMagazinesListingPage.propTypes = {
  data: object,
};
